module.exports = __webpack_public_path__ + "img/foto11.f95e63f9.jpg";